module.exports = __webpack_public_path__ + "static/media/graduated.668edfb3.svg";